import { UserData, PermissionAction } from './authtype';

const usePermissions = () => {
	const storedData = localStorage.getItem('HRMS-data');
	const getData: UserData | null = storedData ? JSON.parse(storedData) : null;

	const isSuperAdmin = getData?.userType === 'superadmin';

	const hasPermission = (moduleName: string, action: PermissionAction): boolean => {
		if (isSuperAdmin) {
			return true;
		}

		const modules = getData?.access?.modules || [];

		const matchedModule = modules.find(
			(mod) => mod.module?.toLowerCase() === moduleName.toLowerCase(),
		);

		return (
			matchedModule?.permissions?.some(
				(perm) => perm.toLowerCase() === action.toLowerCase(),
			) || false
		);
	};

	return { hasPermission };
};

export default usePermissions;
